import { useRef } from "react";

// Lightweight native HTML5 drag-to-reorder list (same pattern used by the Story
// panel). Drag is initiated from a handle: spread `dragHandleProps` onto the
// grip element inside renderItem. Reorders an array of arbitrary items.
export const DragHandleList = ({ items, onReorder, getKey, renderItem, className = "" }) => {
  const from = useRef(null);

  const move = (to) => {
    const f = from.current;
    from.current = null;
    if (f == null || f === to) return;
    const next = [...items];
    const [m] = next.splice(f, 1);
    next.splice(to, 0, m);
    onReorder(next);
  };

  return (
    <div className={className}>
      {items.map((item, i) => (
        <div key={getKey(item, i)} onDragOver={(e) => e.preventDefault()} onDrop={() => move(i)}>
          {renderItem(item, i, {
            draggable: true,
            onDragStart: () => {
              from.current = i;
            },
            onDragEnd: () => {
              from.current = null;
            },
          })}
        </div>
      ))}
    </div>
  );
};
